export default __webpack_public_path__ + "static/media/cardIcon.021c70a7.svg";